import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchData } from "../../api";
import Logo from '../../images/logo-signle-1.svg'
import LogoName from '../../images/logo-name-1.svg'

export default function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [headerData, setHeaderData] = useState(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    fetchData("headers", true).then((data) => setHeaderData(data?.[0]));
  }, []);

  useEffect(() => {
    setAnimate(true);
    const timeout = setTimeout(() => setAnimate(false), 3000);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  if (!headerData) return null;

  return (
    <header className="absolute top-0 left-0 w-full z-50">
      <div className="grid grid-cols-[25%_1fr_25%] items-start gap-10 max-md:grid-cols-2 max-md:gap-56 max-sm:gap-0">
        <div className="relative bg-[#27352C] w-full pt-5 px-10 pb-8 max-sm:p-5 rounded-[0_0_70px_0] max-md:rounded-[0_0_30px_0]">
          <a className="relative flex items-center justify-center gap-4" href="/">
            <img
              src={Logo}
              alt="Logo"
              className={`h-20 w-auto max-lg:h-16 max-md:h-12 transition-all duration-300 ${animate ? "animate-bounce-clover" : ""}`}
            />
            <img
              src={LogoName}
              alt="Logo"
              className="h-20 w-auto max-lg:h-16 max-md:h-12 animate-none"
            />
          </a>
        </div>

        <nav className="hidden md:flex items-center justify-center gap-11 w-full pt-10">
          {headerData?.MenuItems?.map((item, index) => (
            <a
              key={index}
              href={item.URL}
              className="underline-thick font-medium text-lg"
            >
              {item.Label}
            </a>
          ))}
        </nav>

        <div className="max-w-[80%] ml-auto bg-[#27352C]/60 w-full backdrop-blur-sm h-full pt-8 px-14 rounded-[0_0_0_90px] max-lg:px-8 max-md:hidden max-lg:rounded-[0_0_0_50px]">
          <a
            className="w-fit text-nowrap text-md p-3 bg-white rounded-[5px] flex items-center justify-center text-black border-2 font-semibold mx-auto hover:bg-transparent hover:border-2 hover:text-white transition-all"
            href="/contact"
          >
            {headerData?.ButtonText}
          </a>
          <h3 className="py-16 mt-40 font-medium text-white max-2xl:mt-32">
            Maak Van Jouw Bouwdroom Realiteit
          </h3>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden focus:outline-none max-md:ml-auto max-md:pr-3"
        >
          <img
            src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${headerData.HamburgerIcon?.url}`}
            alt="Menu"
            className="w-10"
          />
        </button>
      </div>

      {menuOpen && (
        <nav className="lg:hidden bg-[#27352C] w-full h-full fixed left-0 top-0 p-6 flex flex-col items-center gap-6">
          <button
            onClick={() => setMenuOpen(false)}
            className="absolute text-white font-bold right-6 top-6"
          >
            X
          </button>
          {headerData?.MenuItems?.map((item, index) => (
            <a key={index} href={item.URL} className="text-white underline-thick">
              {item.Label}
            </a>
          ))}
          <a
            className="w-full max-w-[200px] h-12 bg-white rounded-[5px] flex items-center justify-center text-black font-semibold text-center px-4"
            href="/contact"
          >
            {headerData?.ButtonText}
          </a>
        </nav>
      )}
    </header>
  );
}
